// Models
/**
 * Implementation of ICategoryFormatting with minified serialization
 *
 * This class enforces an "all or nothing" approach - either all 4 color properties
 * are provided with valid non-empty values, or the CategoryFormatting should not exist.
 *
 * Serialization Format:
 * Uses minimized property names to reduce stored data size since this data is preserved/serialized:
 * - backgroundColor → "bc"
 * - hoverBackgroundColor → "hbc"
 * - hoverBorderColor → "hbrc"
 * - textColor → "tc"
 *
 * Serialized structure: { bc: string, hbc: string, hbrc: string, tc: string }
 */ export class CategoryFormatting {
    /**
     * Creates a CategoryFormatting instance from a serialized resource string
     */ static fromResource(resource) {
        let parsed;
        try {
            parsed = JSON.parse(resource);
        } catch  {
            throw new Error("Invalid resource: Failed to parse CategoryFormatting JSON");
        }
        if (!parsed || typeof parsed !== "object") {
            throw new Error("Invalid resource: Failed to parse CategoryFormatting JSON");
        }
        if (!parsed.bc || !parsed.hbc || !parsed.hbrc || !parsed.tc) {
            throw new Error("Invalid resource: CategoryFormatting requires all color properties (bc, hbc, hbrc, tc) to be present and non-empty");
        }
        return new CategoryFormatting(parsed.bc, parsed.hbc, parsed.hbrc, parsed.tc);
    }
    /**
     * Validates if an ICategoryFormatting object has all required properties
     */ static isValid(formatting) {
        return !!(formatting.backgroundColor && formatting.hoverBackgroundColor && formatting.hoverBorderColor && formatting.textColor);
    }
    /**
     * Creates a clone of this CategoryFormatting instance
     */ getClone() {
        return new CategoryFormatting(this.backgroundColor, this.hoverBackgroundColor, this.hoverBorderColor, this.textColor);
    }
    /**
     * Creates a new CategoryFormatting instance with a property updated
     */ setProperty(key, value) {
        const clone = this.getClone();
        clone[key] = value;
        return clone;
    }
    /**
     * Serializes the formatting to a minified JSON string
     */ forSerialization() {
        return JSON.stringify({
            bc: this.backgroundColor,
            hbc: this.hoverBackgroundColor,
            hbrc: this.hoverBorderColor,
            tc: this.textColor
        });
    }
    /**
     * Checks if the formatting is empty (no properties set)
     */ isEmpty() {
        return !this.backgroundColor && !this.hoverBackgroundColor && !this.hoverBorderColor && !this.textColor;
    }
    constructor(backgroundColor, hoverBackgroundColor, hoverBorderColor, textColor){
        this.backgroundColor = backgroundColor;
        this.hoverBackgroundColor = hoverBackgroundColor;
        this.hoverBorderColor = hoverBorderColor;
        this.textColor = textColor;
    }
}
